import $ from 'jquery';
import pad from 'pad-left';

const instances = [];

function cardsSlider(selector = '.cards--slider .cards__wrap', settings = {}) {
	return $(selector).each((index, node) => {
		const $node = $(node);
		const $slides = $node.find('> .card');
		const $pager = $('<div class="pager cards__pager"></div>').insertAfter($node);
		const $current = $(`<div class="pager__current">${pad(1, 2, 0)}</div>`).appendTo($pager);
		const $total = $(`<div class="pager__total">${pad($slides.length, 2, 0)}</div>`).appendTo($pager);

		const config = $.extend({
			adaptiveHeight: true,
			slidesToShow: 1,
			mobileFirst: true,
			speed: 200,
			touchThreshold: 5,
			arrows: true,
			appendArrows: $pager,
			responsive: [
				{
					breakpoint: 600,
					settings: {
						touchThreshold: 10,
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 768,
					settings: {
						touchThreshold: 10,
						slidesToShow: 3,
					}
				},
				{
					breakpoint: 960,
					settings: {
						touchThreshold: 10,
						slidesToShow: 4,
					}
				}
			],
		}, settings);

		const handleResize = (slick) => {
			if (slick.slideCount > slick.options.slidesToShow) {
				$pager.removeAttr('hidden');
			} else {
				$pager.attr('hidden', true);
			}
		}

		$node.on('afterChange', (event, slick, currentSlide, nextSlide) => $current.text(pad(currentSlide + 1, 2, 0)));
		$node.on('breakpoint', (event, slick, breakpoint) => handleResize(slick));
		$node.on('init', (event, slick) => handleResize(slick));

		let slider = $node.slick(config);

		instances.push($node);
		window.gfi_sliders.push(slider);
	});
}

document.addEventListener('DOMContentLoaded', () => cardsSlider());

export default {
	cardsSlider,
	instances,
}
